import { createStore, applyMiddleware, compose } from 'redux';
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
  useStore,
} from 'react-redux';
import thunk, { ThunkDispatch } from 'redux-thunk';
import reducers from './reducers';
import { getUserFromLocalStorage } from 'nomadLocalStorage';
import { IAction } from 'actions/types';

const composeEnhancers =
  // @ts-expect-error because __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ is set by the browser
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as typeof compose) || compose;

export const store = createStore(
  reducers,
  {
    user: getUserFromLocalStorage(),
  },
  composeEnhancers(applyMiddleware(thunk))
);

export type TRootState = ReturnType<typeof store.getState>;
export type TAppDispatch = ThunkDispatch<TRootState, any, IAction>;
export type TAppStore = typeof store;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => TAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
export const useAppStore: () => TAppStore = useStore;
